import React from 'react'
import InstructorNavbar from "../components/instructor/InstructorNavbar"
import AddMarks from '../components/instructor/AddMarks'

const AddMarksPage = () => {
  return (
    <div>
       <InstructorNavbar/>
       <AddMarks/>
    </div>
  )
}

export default AddMarksPage